import { DeviceOs, DeviceType } from '@/logic/main/types';
import { mapUrl } from '@/logic/main/utils';
import Window from '@/ports-frontend/Window';

export const createGameLaunchModel = () => {
  const model = {
    openGameInCurrentTab: (
      url: string,
      deviceType: DeviceType,
      deviceOs: DeviceOs
    ) => {
      Window.redirectToUrl(mapUrl(url, deviceType, deviceOs));
    },
  };

  return model;
};
